import { PersistentHistory } from '@frontend/auction/src/helpers/PersistentHistory';
import { SPAListItem } from './spa-list-item';

export class SPAList extends HTMLDivElement {
  static singleton: SPAList;

  constructor() {
    super();

    SPAList.singleton = this;
  }

  connectedCallback() {
    this.initRemoveListener();
    this.initNameChangeListener();
    this.initSumChangeListener();
  }

  getItems = () =>
    Array.from(this.querySelectorAll<SPAListItem>('[is="spa-list-item"]'), element => ({
      element,

      name: element.name,
      sum: element.sum,
    }));

  sortItems = () => {
    const items = this.getItems();

    const sorted = items.toSorted((a, b) => b.sum - a.sum);

    if (sorted.some((sortItem, index) => sortItem.element !== items[index]!.element)) {
      sorted.forEach(({ element }) => this.appendChild(element));
    }
  };

  initRemoveListener = () => {
    this.addEventListener('remove', event => {
      const item = event.target;

      if (item && item instanceof HTMLElement) {
        item.remove();

        this.save();
      }
    });
  };

  initNameChangeListener = () => {
    this.addEventListener('namechange', event => {
      const item = event.target;

      if (item === this.lastElementChild) {
        this.appendChild(new SPAListItem());
      }

      this.save();
    });
  };

  initSumChangeListener = () => {
    this.addEventListener('sumchange', () => {
      this.sortItems();

      this.save();
    });
  };

  save = () => {
    const items = this.getItems()
      .map(({ name, sum }) => ({ name, sum }))
      .filter(item => item.name !== '' || item.sum !== 0);

    PersistentHistory.update(items);
  };

  load = (items: { name: string; sum: number }[]) => {
    const currentItems = this.getItems();

    items.forEach((item, index) => {
      const currentItem = currentItems[index];

      if (currentItem) {
        currentItem.element.name = item.name;
        currentItem.element.sum = item.sum;
      } else {
        const newItem = new SPAListItem();

        this.appendChild(newItem);

        newItem.name = item.name;
        newItem.sum = item.sum;
      }
    });

    if (currentItems.length > items.length) {
      currentItems.slice(items.length).forEach(currentItem => {
        currentItem.element.name = '';

        if (currentItem.element.sum !== 0) {
          currentItem.element.sum = 0;
        }
      });
    }

    if (items.length === this.getItems().length) {
      this.appendChild(new SPAListItem());
    }
  };
}

customElements.define('spa-list', SPAList, { extends: 'div' });
